<template>
  <div class="card" v-show="currentCardId == 'create-date'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>志望動機書の作成日を入力</h2>
        <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
      </div>
      <div class="card-content">
        <div class="edit-form-list">
          <FormatDateActionFields v-model="formatData.createDate" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FormatDateActionFields from '@/components/format-edit/FormatDateActionFields.vue'
import { useShibouDoukishoFormatData } from '@/composables/format-edit/useShibouDoukishoFormatData'

defineProps<{
  currentCardId?: string
}>()

const formatData = useShibouDoukishoFormatData()
</script>
